import axios from 'axios';
import { upperFirst } from 'lodash-es';

export const getErrorMessage = (err: any): string | undefined => {
  if (err instanceof axios.Cancel) {
    // when request is cancelled there is no need to throw error.
    return;
  }

  let errData: any;

  console.error(err);

  let message: string = err.toString();

  if (err.response) {
    errData = err.response.data;
  } else if (err?.errors) {
    errData = err;
  }
  if (errData.errors && Array.isArray(errData.errors)) {
    if (errData.errors[0] && errData.errors[0].wall_check) {
      message = errData.errors[0].wall_check;
    } else {
      message = errData.errors[0].message;
    }
  } else if (
    typeof errData.errors === 'string' ||
    errData.errors instanceof String
  ) {
    message = errData.errors;
  } else if (errData.errors) {
    let errors: Array<string> = [];
    Object.keys(errData.errors).forEach(function (key) {
      errors.push(errData.errors[key]);
    });
    message = errors.join(' ');
    return message;
  }
  return message;
};

export const getErrorMessagesAsArray = (err: any): string[] | undefined => {
  if (err instanceof axios.Cancel) {
    // when request is cancelled there is no need to throw error.
    return;
  }

  let errData: any;

  console.error(err);

  let message: string = err.toString();

  if (err.response) {
    errData = err.response.data;
  } else if (err?.errors) {
    errData = err;
  }
  if (errData.errors && Array.isArray(errData.errors)) {
    if (errData.errors[0] && errData.errors[0].wall_check) {
      message = errData.errors[0].wall_check;
    } else {
      message = errData.errors[0].message;
    }
  } else if (
    typeof errData.errors === 'string' ||
    errData.errors instanceof String
  ) {
    message = errData.errors;
  } else if (errData.errors) {
    return parseDBErrors(errData.errors);
  }
  return [message];
};

export const formatErrorsAsList = (apiErrors: any): Array<string> => {
  if (typeof apiErrors === 'string') {
    return [apiErrors];
  }
  if (typeof apiErrors === 'object' && Array.isArray(apiErrors.errors) && apiErrors.errors[0]?.message) {
    return [apiErrors.errors[0].message];
  }
  if (typeof apiErrors === 'object' && apiErrors.errors) {
    apiErrors = apiErrors.errors;
  }

  return parseDBErrors(apiErrors);
};

const parseDBErrors = (e: any) => {
  return Object.entries(e).map(([key, value]) => {
    if (typeof e[0] !== 'string') {
      return `${upperFirst(
        key.replaceAll('properties.', '').replaceAll('_', ' ')
      )}: ${value}`;
    } else {
      return `${value}`;
    }
  });
};
